module.exports = __webpack_public_path__ + "img/ilus01.9a611471.gif";